import { Bookmark } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const InterventionReportIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <Bookmark width={size} height={size} color={color} {...rest} />;

InterventionReportIcon.displayName = 'InterventionReportIcon';

export default InterventionReportIcon;
